/**
 * Status pills, in the workspace design system's tones (see components/ui).
 *
 * Kept as a class string rather than a component because it is applied to plain
 * <span>s all over the customer and admin tables; the shape here matches the UI
 * kit's <Badge>, so the two read identically side by side.
 */
const STATUS_TONES = {
  success:
    "bg-emerald-500/15 text-emerald-700 ring-1 ring-inset ring-emerald-500/20 dark:text-emerald-300",
  info: "bg-sky-500/15 text-sky-700 ring-1 ring-inset ring-sky-500/20 dark:text-sky-300",
  danger: "bg-rose-500/15 text-rose-600 ring-1 ring-inset ring-rose-500/20 dark:text-rose-300",
  warning: "bg-amber-500/15 text-amber-700 ring-1 ring-inset ring-amber-500/20 dark:text-amber-300",
  neutral:
    "bg-gray-100 text-gray-600 ring-1 ring-inset ring-gray-900/5 dark:bg-[#262628] dark:text-slate-300 dark:ring-white/10",
};

const STATUS_TONE_BY_VALUE = {
  ACTIVE: "success",
  COMPLETED: "success",
  OPEN: "success",
  PAID: "success",
  POSSIBLE: "success",
  PROCESSED: "success",
  REFUNDED: "info",
  NOT_SUPPORTED_SOLUTION: "danger",
  DEACTIVE: "danger",
  CANCELED: "danger",
  CLOSED: "danger",
  UNPAID: "danger",
  NOT_POSSIBLE: "danger",
  PENDING: "warning",
  IN_PROGRESS: "warning",
};

/** The tone name for a status — useful when a row, not a pill, carries the colour. */
export const getStatusTone = (status) => STATUS_TONE_BY_VALUE[status] || "neutral";

export const getStatusBadgeClass = (status) =>
  `inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-[0.06em] ${
    STATUS_TONES[getStatusTone(status)]
  }`;

/** "IN_PROGRESS" → "In progress", for display next to the pill styling above. */
export const formatStatus = (status) =>
  String(status || "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/^./, (c) => c.toUpperCase());

export const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
